













































import { Prop, Component, Vue } from 'vue-property-decorator'
import { Agenda, Relatie } from '@/api/realworks-types'
import { escapeHtml } from '@/helpers/html'

@Component
export default class TypeformResponsesDetailAnswer extends Vue {
    @Prop({ required: true }) agenda!: Agenda
    @Prop({ required: true }) medewerker!: Relatie

    get googleMapsUrl(): string {
        return [
            'https://www.google.nl/maps/place/',
            this.agenda.locatie
                .replaceAll(' ', '+'),

        ].join('')
    }

    get hasExtraInfo(): boolean {
        return this.agenda.extraInfo && this.agenda.extraInfo.length > 0
    }

    get formattedExtraInfo(): string {
        // Plain text from Realworks: escaped, so "Jan <jan@makelaar.nl>" stays as typed instead of becoming a tag
        return escapeHtml(this.agenda.extraInfo).replaceAll('\n', '<br>')
    }
}
